import merge from 'lodash/merge'
import onelogTheme from '../../shared/themes/onelog'
import {getLang} from '../../../utils/stringUtils'
import config from '../../../config'

const lang = getLang(window.location.search) || 'de'
const authorizeRedirectURL = `${config.loginUrl}/?lang=${lang}`

export default merge({}, onelogTheme, {
  brand: {
    authorizeRedirectURL,
  },
})
